/**
 * Created by mlindegarde on 11/9/2015.
 */
var CharlesScott = CharlesScott || {};

CharlesScott.CollectionMenu = {
    init: function(){
        var _headers = $('[data-object="item-header"]');
        var _bodies = $('[data-object="item-body"]');
      	var _hiddenClass = 'body-hidden';

        var initHeaders = function(){
            _headers.click(function(event){
              	var dataObject = $(event.target).data('object');
              
                if(dataObject !== 'item-header' && dataObject !== 'item-view-details'){
                    return;
                }

                event.preventDefault();

                var isHidden = $(this).next().hasClass(_hiddenClass);

                _bodies.addClass(_hiddenClass);

                if(isHidden){
                    $(this).next().removeClass(_hiddenClass);
                }
            })
        };

        initHeaders();
    }
}
